export type TranslationKey =
  | 'connecting'
  | 'connectionEstablished'
  | 'connectionFailed'
  | 'waitingForAvatar'
  | 'waitingCozy'
  | 'preparingInterview'
  | 'preparingInterviewHint'
  | 'connectionFailedTitle'
  | 'retry'
  | 'readyToStart'
  | 'startInterview'
  | 'next'
  | 'end'
  | 'sending'
  | 'submit'
  | 'preparingQuestion'
  | 'giveAnswerAndContinue'
  | 'movingToNext'
  | 'recordingActive'
  | 'aiInterviewer'
  | 'avatarVoiceFemale'
  | 'avatarVoiceMale'
  | 'welcomeMessage'
  | 'clickToStart'
  | 'errorOccurred'
  | 'cameraAccessFailed'
  | 'thankYouForInterview'
  | 'emailPrompt'
  | 'firstNameLabel'
  | 'lastNameLabel'
  | 'emailLabel'
  | 'emailPlaceholder'
  | 'enterValidEmail'
  | 'errorSendingEmail'
  | 'thankYouVisitUs'
  | 'interviewCompleted'
  | 'interviewAbortedTitle'
  | 'interviewAbortedMessage'
  | 'demoCompleted'
  | 'interviewSummary'
  | 'sectionsCompleted'
  | 'yourResponse'
  | 'processingTranscript'
  | 'candidateLabel'
  | 'transcriptLabel'
  | 'progress'
  | 'settings'
  | 'cancel'
  | 'pipEnlarge'
  | 'pipMinimize'
  | 'transcriptHide'
  | 'fontDecrease'
  | 'fontIncrease'
  | 'micDisable'
  | 'micEnable'
  | 'endConfirmTitle'
  | 'endConfirmMessage'
  | 'camera'
  | 'microphone'
  | 'speaker'
  | 'device'
  | 'level'
  | 'off'
  | 'speakToTest'
  | 'test'
  | 'playTone'
  | 'speakerSelectionNotSupported'
  | 'frontCamera'
  | 'backCamera'
  | 'internalMicrophone'
  | 'headsetMicrophone'
  | 'speakerphone'
  | 'earpiece'
  | 'internalSpeaker'
  | 'headphones'
  | 'joinConsentTitle'
  | 'joinConsentIntroWithRecording'
  | 'joinConsentIntroNoRecording'
  | 'joinConsentGdprNote'
  | 'joinConsentAgree'
  | 'joinConsentDecline'
  | 'joinStatusExpired'
  | 'joinStatusCancelled'
  | 'joinStatusCancelledByRecruiter'
  | 'joinStatusCompleted'
  | 'joinStatusFailed'
  | 'joinStatusInProgress'
  | 'joinStatusLinkInvalid'
  | 'joinStatusNetworkError'
  | 'finalizingInterview'
  | 'mediaPermissionDenied'
  | 'mediaNoDevice'
  | 'mediaDeviceBusy'
  | 'mediaStartFailed'
  | 'deviceSwitchFailed'

const translations: Record<string, Record<TranslationKey, string>> = {
  de: {
    connecting: 'Verbindung wird hergestellt...',
    connectionEstablished: 'Verbindung hergestellt',
    connectionFailed: 'Verbindung fehlgeschlagen. Bitte Seite neu laden.',
    waitingForAvatar: 'Warte auf Avatar-Initialisierung...',
    waitingCozy:
      'Mach es dir gerne schon einmal gemütlich und nimm noch einen Schluck zu trinken – dein Interviewpartner ist gleich für dich da.',
    preparingInterview: 'Einen Moment – dein Interview wird gerade vorbereitet.',
    preparingInterviewHint: 'Mach es dir schon einmal gemütlich, gleich geht es los.',
    connectionFailedTitle: 'Verbindung fehlgeschlagen.',
    retry: 'Erneut versuchen',
    readyToStart: 'Bereit zum Starten des Interviews!',
    startInterview: 'Interview starten',
    next: 'Weiter',
    end: 'Beenden',
    sending: 'Wird gesendet...',
    submit: 'Absenden',
    preparingQuestion: 'Der Interviewer bereitet die nächste Frage vor...',
    giveAnswerAndContinue: 'Bitte gib deine Antwort und klicke dann auf "Weiter"',
    movingToNext: 'Weiter zum nächsten Abschnitt...',
    recordingActive: 'Aufzeichnung läuft – das Interview ist aktiv!',
    aiInterviewer: 'KI Interviewer',
    avatarVoiceFemale: 'Stimme: weiblich',
    avatarVoiceMale: 'Stimme: männlich',
    welcomeMessage: 'Willkommen zu deinem Interview. Klicke auf "Interview starten", um zu beginnen.',
    clickToStart: 'Klicke auf "Interview starten", um zu beginnen...',
    errorOccurred: 'Ein Fehler ist aufgetreten. Bitte versuche es erneut.',
    cameraAccessFailed: 'Kamera/Mikrofon konnte nicht zugegriffen werden.',
    thankYouForInterview: 'Danke für dein Interesse!',
    emailPrompt: 'Danke, dass du uns hilfst, TEMBO zu verbessern!',
    firstNameLabel: 'Vorname',
    lastNameLabel: 'Nachname',
    emailLabel: 'E-Mail-Adresse',
    emailPlaceholder: 'deine.email@example.com',
    enterValidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    errorSendingEmail: 'Fehler beim Senden der E-Mail. Bitte versuche es erneut.',
    thankYouVisitUs: 'Danke für dein Interesse! Besuche uns jederzeit auf tlou.ai.',
    interviewCompleted: 'Interview erfolgreich abgeschlossen!',
    interviewAbortedTitle: 'Interview beendet',
    interviewAbortedMessage:
      'Dein Fortschritt wurde nicht gespeichert. Du kannst den Link später erneut öffnen und von vorne beginnen.',
    demoCompleted: 'Demo erfolgreich abgeschlossen!',
    interviewSummary: 'Interview-Zusammenfassung',
    sectionsCompleted: 'Abschnitte abgeschlossen',
    yourResponse: 'Deine Antwort',
    processingTranscript: 'Transkript wird verarbeitet...',
    candidateLabel: 'Kandidat/in',
    transcriptLabel: 'Sprechertext',
    progress: 'Fortschritt',
    settings: 'Einstellungen',
    cancel: 'Abbrechen',
    pipEnlarge: 'Vergrößern',
    pipMinimize: 'Minimieren',
    transcriptHide: 'Ausblenden',
    fontDecrease: 'Schrift verkleinern',
    fontIncrease: 'Schrift vergrößern',
    micDisable: 'Mikrofon deaktivieren',
    micEnable: 'Mikrofon aktivieren',
    endConfirmTitle: 'Interview beenden',
    endConfirmMessage:
      'Wenn Sie jetzt beenden, wird Ihr bisheriger Fortschritt nicht gespeichert. Sie können den Link später erneut öffnen, müssen das Interview dann aber komplett von vorne beginnen. Möchten Sie wirklich beenden?',
    camera: 'Kamera',
    microphone: 'Mikrofon',
    speaker: 'Lautsprecher',
    device: 'Gerät',
    level: 'Pegel',
    off: 'Aus',
    speakToTest: 'Sprich zum Testen',
    test: 'Test',
    playTone: 'Ton abspielen',
    speakerSelectionNotSupported: 'Lautsprecherwahl nicht unterstützt in diesem Browser',
    frontCamera: 'Frontkamera',
    backCamera: 'Rückkamera',
    internalMicrophone: 'Internes Mikrofon',
    headsetMicrophone: 'Headset-Mikrofon',
    speakerphone: 'Lautsprecher',
    earpiece: 'Ohrhörer',
    internalSpeaker: 'Interner Lautsprecher',
    headphones: 'Kopfhörer',
    joinConsentTitle: 'Bevor wir starten',
    joinConsentIntroWithRecording:
      'Dieses Interview mit {companyName} ({jobTitle}) wird mit Bild und Ton aufgezeichnet. Aufzeichnung wird {retentionDays} Tage gespeichert.',
    joinConsentIntroNoRecording:
      'Dieses Interview mit {companyName} ({jobTitle}) wird nicht aufgezeichnet — nur ein Transkript wird erstellt.',
    joinConsentGdprNote:
      'Mit dem Klick auf „Einverstanden" erklärst du dich mit der Verarbeitung deiner Daten gemäß unserer Datenschutzerklärung einverstanden.',
    joinConsentAgree: 'Einverstanden, fortfahren',
    joinConsentDecline: 'Ablehnen',
    joinStatusExpired:
      'Dieser Link ist abgelaufen. Bitte wende dich an deinen Recruiter für einen neuen Link.',
    joinStatusCancelled: 'Du hast die Teilnahme abgelehnt.',
    joinStatusCancelledByRecruiter: 'Diese Sitzung wurde von Tenant-Seite abgesagt.',
    joinStatusCompleted: 'Diese Sitzung wurde bereits abgeschlossen.',
    joinStatusFailed:
      'Bei dieser Sitzung ist ein technischer Fehler aufgetreten. Bitte wende dich an deinen Recruiter.',
    joinStatusInProgress: 'Diese Sitzung läuft bereits in einem anderen Browser-Fenster.',
    joinStatusLinkInvalid: 'Dieser Link ist ungültig.',
    joinStatusNetworkError: 'Verbindungsfehler. Bitte versuche es später erneut.',
    finalizingInterview: 'Interview wird abgeschlossen…',
    mediaPermissionDenied:
      'Zugriff auf Kamera/Mikrofon wurde verweigert. Bitte erlaube den Zugriff in den Browser-Einstellungen und versuche es erneut.',
    mediaNoDevice:
      'Keine Kamera oder kein Mikrofon gefunden. Bitte schließe ein Gerät an und versuche es erneut.',
    mediaDeviceBusy:
      'Kamera/Mikrofon wird gerade von einer anderen Anwendung verwendet. Bitte schließe diese und versuche es erneut.',
    mediaStartFailed:
      'Kamera/Mikrofon konnte nicht gestartet werden. Bitte versuche es erneut.',
    deviceSwitchFailed:
      'Gerätewechsel fehlgeschlagen. Bitte prüfe, ob das Gerät verfügbar ist.',
  },
  en: {
    connecting: 'Establishing connection...',
    connectionEstablished: 'Connection established',
    connectionFailed: 'Connection failed. Please refresh the page.',
    waitingForAvatar: 'Waiting for avatar initialisation...',
    waitingCozy:
      'Make yourself comfortable and grab a sip of something to drink – your interview partner will be with you shortly.',
    preparingInterview: 'One moment – your interview is being prepared.',
    preparingInterviewHint: 'Get comfortable, we are about to begin.',
    connectionFailedTitle: 'Connection failed.',
    retry: 'Try again',
    readyToStart: 'Ready to start the interview!',
    startInterview: 'Start interview',
    next: 'Next',
    end: 'End',
    sending: 'Sending...',
    submit: 'Submit',
    preparingQuestion: 'The interviewer is preparing the next question...',
    giveAnswerAndContinue: 'Please give your answer and then click "Next"',
    movingToNext: 'Moving to the next section...',
    recordingActive: 'Recording active – the interview is live!',
    aiInterviewer: 'AI Interviewer',
    avatarVoiceFemale: 'Voice: female',
    avatarVoiceMale: 'Voice: male',
    welcomeMessage: 'Welcome to your interview. Click "Start interview" to begin.',
    clickToStart: 'Click "Start interview" to begin...',
    errorOccurred: 'An error occurred. Please try again.',
    cameraAccessFailed: 'Could not access camera/microphone.',
    thankYouForInterview: 'Thank you for your interest!',
    emailPrompt: 'Thank you for helping us improve TEMBO!',
    firstNameLabel: 'First name',
    lastNameLabel: 'Last name',
    emailLabel: 'Email address',
    emailPlaceholder: 'your.email@example.com',
    enterValidEmail: 'Please enter a valid email address.',
    errorSendingEmail: 'Error sending email. Please try again.',
    thankYouVisitUs: 'Thank you for your interest! Visit us anytime at tlou.ai.',
    interviewCompleted: 'Interview completed successfully!',
    interviewAbortedTitle: 'Interview ended',
    interviewAbortedMessage:
      'Your progress was not saved. You can reopen the link later and start again from the beginning.',
    demoCompleted: 'Demo completed successfully!',
    interviewSummary: 'Interview Summary',
    sectionsCompleted: 'sections completed',
    yourResponse: 'Your response',
    processingTranscript: 'Processing transcript...',
    candidateLabel: 'Candidate',
    transcriptLabel: 'Transcript',
    progress: 'Progress',
    settings: 'Settings',
    cancel: 'Cancel',
    pipEnlarge: 'Enlarge',
    pipMinimize: 'Minimize',
    transcriptHide: 'Hide',
    fontDecrease: 'Decrease font size',
    fontIncrease: 'Increase font size',
    micDisable: 'Disable microphone',
    micEnable: 'Enable microphone',
    endConfirmTitle: 'End interview',
    endConfirmMessage:
      'If you end now, your progress so far will not be saved. You can reopen the link later, but you will then have to start the interview again from the beginning. Do you really want to end?',
    camera: 'Camera',
    microphone: 'Microphone',
    speaker: 'Speaker',
    device: 'Device',
    level: 'Level',
    off: 'Off',
    speakToTest: 'Speak to test',
    test: 'Test',
    playTone: 'Play tone',
    speakerSelectionNotSupported: 'Speaker selection not supported in this browser',
    frontCamera: 'Front camera',
    backCamera: 'Rear camera',
    internalMicrophone: 'Internal microphone',
    headsetMicrophone: 'Headset microphone',
    speakerphone: 'Speakerphone',
    earpiece: 'Earpiece',
    internalSpeaker: 'Internal speaker',
    headphones: 'Headphones',
    joinConsentTitle: 'Before we start',
    joinConsentIntroWithRecording:
      'This interview with {companyName} ({jobTitle}) will be recorded with video and audio. The recording will be stored for {retentionDays} days.',
    joinConsentIntroNoRecording:
      'This interview with {companyName} ({jobTitle}) will not be recorded — only a transcript will be created.',
    joinConsentGdprNote:
      'By clicking "Agree", you consent to the processing of your data in accordance with our privacy policy.',
    joinConsentAgree: 'Agree, continue',
    joinConsentDecline: 'Decline',
    joinStatusExpired:
      'This link has expired. Please contact your recruiter for a new link.',
    joinStatusCancelled: 'You have declined to participate.',
    joinStatusCancelledByRecruiter: 'This session was cancelled by the tenant.',
    joinStatusCompleted: 'This session has already been completed.',
    joinStatusFailed:
      'A technical error occurred during this session. Please contact your recruiter.',
    joinStatusInProgress: 'This session is already running in another browser window.',
    joinStatusLinkInvalid: 'This link is invalid.',
    joinStatusNetworkError: 'Connection error. Please try again later.',
    finalizingInterview: 'Finalizing your interview…',
    mediaPermissionDenied:
      'Camera/microphone access was denied. Please allow access in your browser settings and try again.',
    mediaNoDevice:
      'No camera or microphone found. Please connect a device and try again.',
    mediaDeviceBusy:
      'Your camera/microphone is in use by another application. Please close it and try again.',
    mediaStartFailed:
      'Could not start your camera/microphone. Please try again.',
    deviceSwitchFailed:
      'Switching the device failed. Please check that it is available.',
  },
}

export function t(lang: string, key: TranslationKey): string {
  return translations[lang]?.[key] ?? translations['en'][key] ?? key
}

export function useT(lang: string) {
  return (key: TranslationKey) => t(lang, key)
}

export function interpolate(
  template: string,
  vars: Record<string, string | number>,
): string {
  return Object.entries(vars).reduce(
    (acc, [k, v]) => acc.split(`{${k}}`).join(String(v)),
    template,
  )
}
